import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { privateRoutes, routes } from "./pages/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Assets/css/style.css";
import "./Assets/css/responsive.css";
import AuthLayout from "./layout/Auth/authLayout";
import MainLayout from "./layout/MainLayout/MainLayout";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useSocket } from "./Socket/socketProvider";
import { useEffect } from "react";
import HotelRefreshBoundary from "./components/HotelBoundary";
// Helper function to play notification sound using Web Audio API

async function playNotificationSound() {
  const notificationSound = document.getElementById("notificationSound");
  try {
    notificationSound.currentTime = 0;
    notificationSound
      .play()
      .then(() => console.log("Sound played"))
      .catch((a) => {
        console.log("Sound play failed", a);
      });
  } catch (err) {
    console.log("Sound play failed", err);
  }
}

function App() {
  const isAuthenticated = useSelector((s) => s.login?.token);
  let token = localStorage.getItem("token");
  const { t } = useTranslation();

  const { socket } = useSocket();
  useEffect(() => {
    if (socket) {
      socket.on("new_notification", (data) => {
        playNotificationSound();
      });
    }
  }, [socket]);

  return (
     <HotelRefreshBoundary>
    <Routes>
      {isAuthenticated || token ? (
        <Route element={<MainLayout />}>
          <Route path="*" element={<Navigate replace to="/dashboard" />} />
          {privateRoutes.map((data, index) => (
            <Route
              onUpdate={() => window.scrollTo(0, 0)}
              exact={true}
              path={data.path}
              element={data.component}
              key={index}
            />
          ))}
        </Route>
      ) : (
        <Route element={<AuthLayout />}>
          <Route path="*" element={<Navigate to="/login" />} />
          {routes.map((data, index) => (
            <Route
              onUpdate={() => window.scrollTo(0, 0)}
              exact={true}
              path={data.path}
              element={data.component}
              key={index}
            />
          ))}
        </Route>
      )}
    </Routes>
    </HotelRefreshBoundary>
  );
}

export default App;
